<template>
  <div class="container">
    <div v-if="!finished">
      <h2>{{question}}</h2>

      <div v-for="q in options">
          <button type="button" class="btn btn-primary btn-lg btn-block" @click="updateQuestion(q)">{{q.option}}</button>
          <br>
      </div>
    </div>
    <div v-else>
      <h1>{{result.result}}</h1>

      <div v-if="result.positive">
        <img class="img-fluid" src="static/love.jpg">
      </div>

      <div v-else>
        <img class="img-fluid" src="static/vuil.jpg">
      </div>

      <button type="button" class="btn btn-primary btn-lg btn-block" @click="reset">Opnieuw?</button>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'hello',
    data () {
      return {
        questions: {
          "question": "Is de kaas Nederlands?",
          "options": [
            {
              "option": "Ja",
              "finished": false,
              "next_question": {
                "question": "Komt de kaas uit de koelkast?",
                "options": [
                  {
                    "option": "Ja",
                    "finished": false,
                    "next_question": {
                      "question": "Is de kaas jong of oud?",
                      "options": [
                        {
                          "option": "(Jong) belegen",
                          "finished": false,
                          "next_question": {
                            "question": "Is de kaas 48+?",
                            "options": [
                              {
                                "option": "Ja",
                                "finished": true,
                                "positive": true,
                                "result": "Ik lust het"
                              },
                              {
                                "option": "Nee",
                                "finished": true,
                                "positive": false,
                                "result": "Waarschijnlijk vind ik het smerig"
                              }
                            ]
                          }
                        },
                        {
                          "option": "Oud",
                          "finished": true,
                          "positive": false,
                          "result": "Waarschijnlijk vind ik het smerig"
                        }
                      ]
                    }
                  },
                  {
                    "option": "Nee",
                    "finished": false,
                    "next_question": {
                      "question": "Zit het op *niet door* pizza, tosti of pasta?",
                      "options": [
                        {
                          "option": "Ja",
                          "finished": true,
                          "positive": true,
                          "result": "Ja, ik lust het"
                        },
                        {
                          "option": "Nee",
                          "finished": true,
                          "positive": false,
                          "result": "Nee, goor"
                        }
                      ]
                    }
                  }
                ]
              }
            },
            {
              "option": "Nee",
              "finished": false,
              "next_question": {
                "question": "Waarschijnlijk lust ik het niet maar oke. Is het mozarella of parmezaans?",
                "options": [
                  {
                    "option": "Ja",
                    "finished": true,
                    "positive": true,
                    "result": "Ja ik lust het"
                  },
                  {
                    "option": "Nee",
                    "finished": true,
                    "positive": false,
                    "photo": "./../assets/vuil.jpeg",
                    "result": "Stop maar, tis vuil!"
                  }
                ]
              }
            }
          ]
        },
        question: "",
        finished: false,
        options: [],
        result: {},
      }
    },

    methods: {
      updateQuestion(option){
          if (option.finished){
              this.finished = true;
              this.result = option;
          }else{
              this.question = option.next_question.question;
              this.options = option.next_question.options;
          }
      },

      reset(){
          this.finished = false;
          this.question = this.questions.question;
          this.options = this.questions.options;
      }
    },

    mounted(){
        this.reset();
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  h1, h2 {
    font-weight: normal;
  }

  ul {
    list-style-type: none;
    padding: 0;
  }

  li {
    display: inline-block;
    margin: 0 10px;
  }

  a {
    color: #42b983;
  }
</style>



// WEBPACK FOOTER //
// Hello.vue?652df932